import React from 'react';

import ModalPrompt from '../../Web/Modal/ModalPrompt/ModalPrompt';

import MapAppOptionsRender from './Render';
import { SheetProps } from './types';

type Props = SheetProps & {
  modalId: string;
};

const MapAppOptions = ({ modalId, payload }: Props) => {
  return (
    <ModalPrompt id={modalId} title="" hasHeader hasHeaderLine>
      <MapAppOptionsRender {...payload} />
    </ModalPrompt>
  );
};

export default MapAppOptions;
